import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-important-announcement',
  templateUrl: './important-announcement.component.html',
  styleUrls: ['./important-announcement.component.scss']
})
export class ImportantAnnouncementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
